import { IconFieldDesignTokens } from '@primeuix/themes/aura/iconfield';

export const iconFieldTokens: IconFieldDesignTokens = {
  icon: {
    color: '{form.field.icon.color}',
  },
  css: () => `
    .p-iconfield .p-select:not(:first-child), .p-iconfield .p-multiselect:not(:first-child), .p-iconfield .p-datepicker:not(:first-child) {
      padding-left: 1.5rem !important;
    }
    .p-iconfield .p-select:not(:last-child), .p-iconfield .p-multiselect:not(:last-child), .p-iconfield .p-datepicker:not(:last-child) {
      padding-right: 1.5rem !important;
    }
  `,
};
